export default __webpack_public_path__ + "static/media/Zara_9781408309087.68dde1dc.jpg";